import {Buttons} from './Buttons'
import {QueryGetCupons} from '../../../graphql'
import {Loader} from '../../../../components/UI/Loader/Loader'
import {useEffect, useMemo, useState} from 'react'
import {BiPlus} from 'react-icons/bi'
import {CreateForm} from './CreateForm'
import {EditForm} from './EditForm'
import {DateTimToView} from '../../../../components/util'
import PaginationComponent, {PageInfo} from '../../../../components/UI/PaginationComponents'
import {format, isValid} from 'date-fns'
import {CardTables} from '../../../../components/UI/CardTables'
import LoadingTable from '../../../../components/UI/CardTables/LoadingTable'
import ErrorTable from '../../../../components/UI/CardTables/ErrorTable'
import {getLaunchesPartners} from '../../../../../services/urbit-gis'
import PaginationComponentGIS from '../../../../components/UI/PaginationComponentGis'
import {RealEstateLaunchPartners} from '../../../../../services/urbit-gis/types'

type Props = {
  filter: string
}

export function Table({filter}: Props) {
  const [paginacao, setPaginacao] = useState({pagina: 0, quantidade: 10})
  const [loading, setLoading] = useState<boolean>(false)
  const [showCreate, setShowCreate] = useState(false)
  const [showEdit, setShowEdit] = useState(false)
  const [id, setId] = useState(null)
  const [error, setError] = useState<string | null>(null)

  const [data, setData] = useState<RealEstateLaunchPartners[]>([])
  const normalizedFilter = filter.trim().toLowerCase()

  const filteredData = useMemo(() => {
    if (!normalizedFilter) {
      return data
    }

    return data.filter((item) => {
      const nome = (item.nome ?? '').toLowerCase()
      const type = (item.type ?? '').toLowerCase()
      return nome.includes(normalizedFilter) || type.includes(normalizedFilter)
    })
  }, [data, normalizedFilter])

  const [pageInfo, setPageInfo] = useState<PageInfo>()
  async function fetchLaunches() {
    try {
      const launches = await getLaunchesPartners(paginacao.pagina, paginacao.quantidade)
      console.log('Lançamentos:', launches)

      // Ordenar os lançamentos pelo campo created_at em ordem decrescente
      const sortedLaunches = launches.data.sort((a, b) => {
        return new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      })

      setData(sortedLaunches)
      setPageInfo(launches.pagination)
    } catch (error) {
      console.error('Erro ao buscar partners:', error)
    }
  }
  useEffect(() => {
    fetchLaunches()
  }, [paginacao])

  function CloseModalCreate() {
    setShowCreate(false)
    fetchLaunches()
    setId(null)
  }

  function OpenModalCreate(id) {
    setShowCreate(true)
    setId(id)
  }
  function CloseModalEdit() {
    setShowEdit(false)
    fetchLaunches()
    setId(null)
  }

  function OpenModalEdit(id) {
    setShowEdit(true)
    setId(id)
  }

  return (
    <>
      <CardTables
        headerTitle={'Incorporadoras'}
        headerSubtTitle={`Listando ${
          filteredData ? filteredData.length : 0
        } registros.`}
        headerToolbar={
          <button
            className='btn btn-sm btn-light-primary'
            onClick={(e) => {
              e.preventDefault()
              OpenModalCreate(null)
            }}
          >
            <BiPlus className='fs-3'></BiPlus>
            Nova Incorporadora
          </button>
        }
        footer={
          data ? (
            <PaginationComponentGIS
              pagesInfo={pageInfo}
              setPagesInfo={(pagina: number, quantidade: number) => {
                setPaginacao({pagina: pagina, quantidade: quantidade})
              }}
            />
          ) : (
            <></>
          )
        }
      >
        <div className='table-responsive  '>
          <table className='table table-striped table-row-dashed  gy-2 gs-6  table-row-bordered   table-hover  table-row-gray-300 align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bold fs-6 text-gray-800 border-bottom border-gray-200'>
                <th className='min-w-150px'>Nome</th>
                <th className='min-w-150px'>Tipo</th>
                <th className='min-w-140px'>Logo</th>
                <th className='min-w-100px text-end'>Ação</th>
              </tr>
            </thead>
            <tbody>
              <LoadingTable loading={loading} />
              <ErrorTable error={error} />
              {filteredData ? (
                filteredData.length > 0 ? (
                  filteredData.map((response) => {
                    return (
                      <tr key={response.id}>
                        {/* <td>{response.id}</td> */}
                        <td>
                          <div className='d-flex align-items-center'>
                            <div className='d-flex justify-content-start flex-column'>
                              <span className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                {response.nome}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>{response.type}</td>
                        <td>
                          <img
                            src={response.logo}
                            width={100}
                            height={'auto'}
                            alt={response.nome}
                          ></img>
                        </td>
                        <td>
                          <Buttons setIdEdit={OpenModalEdit} id={response.id} />
                        </td>
                      </tr>
                    )
                  })
                ) : (
                  <tr>
                    <td colSpan={10} className='text-center'>
                      Nenhum registro encontrado
                    </td>
                  </tr>
                )
              ) : (
                <></>
              )}
            </tbody>
          </table>
        </div>
      </CardTables>
      {showEdit ? <EditForm id={id} show={showEdit} closeModal={CloseModalEdit}></EditForm> : <></>}
      {showCreate ? (
        <CreateForm closeModal={CloseModalCreate} show={showCreate}></CreateForm>
      ) : (
        <></>
      )}
    </>
  )
}
